module.exports = __webpack_public_path__ + "img/appAsset-brand--paypal.ecd965e6.svg";